import React from 'react';
import DealsListing from '../modules/DealsListing';

function DealsListingPage(){
  return <DealsListing/>
}

export default DealsListingPage;